import React, { useEffect, useState } from 'react';
import './PlcDetails.css';
import { useLocation, useNavigate } from 'react-router-dom';
import * as CryptoJS from 'crypto-js';
import { getAssetTagDetail } from '../../services/asset.service';
import { getDepartmentList } from '../../services/user.service';
import FromFieldText from '../../atoms/FromFieldText';
import FromFieldNumber from '../../atoms/FromFieldNumber';
import Box from '@mui/material/Box';
import { DataGrid, GridToolbarContainer, GridToolbarExport } from '@mui/x-data-grid';

// Format date to YYYY-MM-DD, adjusting for IST (UTC+5:30)
function getFormattedDate(dateString) {
    if (!dateString) return null;
    const dte = new Date(dateString);
    dte.setMinutes(dte.getMinutes() + dte.getTimezoneOffset() + 330); // Adjust to IST
    const year = dte.getFullYear();
    const month = String(dte.getMonth() + 1).padStart(2, '0');
    const day = String(dte.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}

// DataGrid columns for logs
const columns1 = [
    { field: 'tag', headerName: 'TAG', width: 200 },
    { field: 'tag_name', headerName: 'Tag Name', width: 250 },
    { field: 'assignment_no', headerName: 'Assignment No', width: 200 },
    {
        field: 'created_at',
        headerName: 'Created Date',
        width: 150,
        renderCell: (params) => <p>{getFormattedDate(params.row.created_at)}</p>,
    },
];

const columns2 = [
    { field: 'tag', headerName: 'TAG', width: 200 },
    { field: 'tag_name', headerName: 'Tag Name', width: 250 },
    { field: 'erassignment_no', headerName: 'Assignment No', width: 200 },
    {
        field: 'created_at',
        headerName: 'Created Date',
        width: 150,
        renderCell: (params) => <p>{getFormattedDate(params.row.created_at)}</p>,
    },
];

const columns3 = [
    { field: 'tag', headerName: 'TAG', width: 200 },
    { field: 'tin_no', headerName: 'Tin No', width: 200 },
    { field: 'cat_of_flag', headerName: 'Category of Flag', width: 250 },
    {
        field: 'created_at',
        headerName: 'Created Date',
        width: 150,
        renderCell: (params) => <p>{getFormattedDate(params.row.created_at)}</p>,
    },
];

const columns4 = [
    { field: 'tag', headerName: 'TAG', width: 200 },
    { field: 'tin_no', headerName: 'Tin No', width: 250 },
    { field: 'cat_of_flag', headerName: 'Category of Flag', width: 200 },
    {
        field: 'created_at',
        headerName: 'Created Date',
        width: 150,
        renderCell: (params) => <p>{getFormattedDate(params.row.created_at)}</p>,
    },
];

// Custom toolbar for DataGrid
function CustomToolbar() {
    return (
        <GridToolbarContainer>
            <GridToolbarExport />
        </GridToolbarContainer>
    );
}

function PlcDetails() {
    const navigate = useNavigate();
    const { search } = useLocation();
    const query = new URLSearchParams(search);
    const Tag = query.get('tag');

    // State declarations
    const [assetInternalRepairLog, setAssetInternalRepairLog] = useState([]);
    const [assetExternalRepairLog, setAssetExternalRepairLog] = useState([]);
    const [assetInternalTransferLog, setAssetInternalTransferLog] = useState([]);
    const [assetBranchTransferLog, setAssetBranchTransferLog] = useState([]);
    const [departments, setDepartments] = useState([]);
    const [activeSection, setActiveSection] = useState(null);
    const [assetTagInfo, setAssetTagInfo] = useState({});
    const [assetInfo, setAssetInfo] = useState({});
    const [allocationInfo, setAllocationInfo] = useState({});
    const [capitalizationInfo, setCapitalizationInfo] = useState({});
    const [depreciationInfo, setDepreciationInfo] = useState({});
    const [internalRepair, setInternalRepair] = useState({});
    const [externalRepair, setExternalRepair] = useState({});
    const [internalTransfer, setInternalTransfer] = useState({});
    const [branchTransfer, setBranchTransfer] = useState({});
    const [errMsg, setErrMsg] = useState('');
    const [imageList, setImageList] = useState([]);
    const [allImageList, setAllImageList] = useState([]);
    const [imageDetails, setAssetImages] = useState([]);
    const [previewImage, setPreviewImage] = useState(null);
    const [imageName, setImageName] = useState('');
    const [headTitle, setHeadTitle] = useState('');
    const [listOptions1, setListData1] = useState([]);
    const [descriptions, setDescriptions] = useState([]);

    // Modal states
    const [showModal, setShowModal] = useState(false);
    const [showModalAllocation, setShowModalAllocation] = useState(false);
    const [showModalCapitalization, setShowModalCapitalization] = useState(false);
    const [showModalDepreciation, setShowModalDepreciation] = useState(false);
    const [showModalInternal, setShowModalInternal] = useState(false);
    const [showModalExternal, setShowModalExternal] = useState(false);
    const [showModalFlagging, setShowModalFlagging] = useState(false);
    const [showModalBranchTransfer, setShowModalBranchTransfer] = useState(false);
    const [showModalDetailsView, setShowModalDetailsView] = useState(false);
    const [showModalAllocationDetailsView, setShowModalAllocationDetailsView] = useState(false);
    const [showModalCapitalizationDetailsView, setShowModalCapitalizationDetailsView] = useState(false);
    const [showModalDepreciationDetailsView, setShowModalDepreciationDetailsView] = useState(false);
    const [showModalInternalRepairView, setShowModalInternalRepairView] = useState(false);
    const [showModalExternalRepairView, setShowModalExternalRepairView] = useState(false);
    const [showModalInternalTransferView, setShowModalInternalTransferView] = useState(false);
    const [showModalBranchTransferView, setShowModalBranchTransferView] = useState(false);
    const [showModalImageView, setShowModalImageView] = useState(false);

    const [dataAvailability, setDataAvailability] = useState({
        assetInfo: false,
        allocationInfo: false,
        capitalizationInfo: false,
        depreciationInfo: false,
        internalRepair: false,
        externalRepair: false,
        internalTransfer: false,
        branchTransfer: false,
        imageDetails: false,
    });

    // Permission setup
    const sModuleId = sessionStorage.getItem('LoggedInModuleId');
    const aAccessModuleId = sModuleId?.split(',') || [];
    const sSubModuleId = sessionStorage.getItem('LoggedInSubModuleId');
    const aSubModuleId = sSubModuleId?.split(',') || [];

    const permissionMapping = {
        'Asset Info': { subModuleId: '18' },
        'Allocation Info': { subModuleId: '29' },
        'Capitalization Info': { subModuleId: '26' },
        'Depreciation Info': { subModuleId: '44' },
        'Internal Repair': { subModuleId: '150' },
        'External Repair': { subModuleId: '153' },
        'Internal Transfer': { subModuleId: '24' },
        'Branch Transfer': { subModuleId: '25' },
        'Asset Images': { subModuleId: '26' },
    };

    // Timeline and tabbed view items
    const timelineItems = [
        {
            icon: 'custom',
            imgSrc: 'icon/asset-addition.png',
            label: 'Asset Info',
            subModuleId: '18',
            clickable: dataAvailability.assetInfo && aSubModuleId.includes('18'),
            hasData: dataAvailability.assetInfo && aSubModuleId.includes('18'),
            onClick: () => setShowModal(true),
        },
        {
            icon: 'custom',
            imgSrc: 'icon/allocation.png',
            label: 'Allocation Info',
            subModuleId: '19',
            clickable: dataAvailability.allocationInfo && aSubModuleId.includes('19'),
            hasData: dataAvailability.allocationInfo && aSubModuleId.includes('19'),
            onClick: () => setShowModalAllocation(true),
        },
        {
            icon: 'custom',
            imgSrc: 'icon/Finance-Operation.png',
            label: 'Capitalization Info',
            subModuleId: '20',
            clickable: dataAvailability.capitalizationInfo && aSubModuleId.includes('20'),
            hasData: dataAvailability.capitalizationInfo && aSubModuleId.includes('20'),
            onClick: () => setShowModalCapitalization(true),
        },
        {
            icon: 'custom',
            imgSrc: 'icon/depreciation.png',
            label: 'Depreciation Info',
            subModuleId: '21',
            clickable: dataAvailability.depreciationInfo && aSubModuleId.includes('21'),
            hasData: dataAvailability.depreciationInfo && aSubModuleId.includes('21'),
            onClick: () => setShowModalDepreciation(true),
        },
        {
            icon: 'custom',
            imgSrc: 'icon/internal-repair.png',
            label: 'Internal Repair',
            subModuleId: '22',
            clickable: dataAvailability.internalRepair && aSubModuleId.includes('22'),
            hasData: dataAvailability.internalRepair && aSubModuleId.includes('22'),
            onClick: () => setShowModalInternal(true),
        },
        {
            icon: 'custom',
            imgSrc: 'icon/external-repair.png',
            label: 'External Repair',
            subModuleId: '23',
            clickable: dataAvailability.externalRepair && aSubModuleId.includes('23'),
            hasData: dataAvailability.externalRepair && aSubModuleId.includes('23'),
            onClick: () => setShowModalExternal(true),
        },
        {
            icon: 'custom',
            imgSrc: 'icon/flagging.png',
            label: 'Internal Transfer',
            subModuleId: '24',
            clickable: dataAvailability.internalTransfer && aSubModuleId.includes('24'),
            hasData: dataAvailability.internalTransfer && aSubModuleId.includes('24'),
            onClick: () => setShowModalFlagging(true),
        },
        {
            icon: 'custom',
            imgSrc: 'icon/branch-transfer.png',
            label: 'Branch Transfer',
            subModuleId: '25',
            clickable: dataAvailability.branchTransfer && aSubModuleId.includes('25'),
            hasData: dataAvailability.branchTransfer && aSubModuleId.includes('25'),
            onClick: () => setShowModalBranchTransfer(true),
        },
    ];

    const tabItems = [
        ...timelineItems,
        {
            icon: 'custom',
            imgSrc: 'icon/image-list.png',
            label: 'Asset Images',
            subModuleId: '26',
            clickable: dataAvailability.imageDetails && aSubModuleId.includes('26'),
            hasData: dataAvailability.imageDetails && aSubModuleId.includes('26'),
            onClick: () => setShowModalImageView(true),
        },
    ];

    // Filter items based on permissions
    const filteredTimelineItems = timelineItems.filter((item) => aSubModuleId.includes(item.subModuleId));
    const filteredTabItems = tabItems.filter((item) => aSubModuleId.includes(item.subModuleId));

    // Fetch asset details
    useEffect(() => {
        if (!Tag) {
            setErrMsg('No Tag Provided');
            return;
        }

        let decryptedTagId = null;
        try {
            const decryptedBytes = CryptoJS.AES.decrypt(
                Tag.replace(/ /g, '+'),
                process.env.REACT_APP_ENCRYPT_SECRET_KEY
            );
            decryptedTagId = JSON.parse(decryptedBytes.toString(CryptoJS.enc.Utf8)).tag;

            const EncryptData = CryptoJS.AES.encrypt(
                JSON.stringify({
                    param_data: { tag: decryptedTagId },
                    authToken: sessionStorage.getItem('LoggedInToken'),
                }),
                process.env.REACT_APP_ENCRYPT_SECRET_KEY
            ).toString();

            const oData = { token: EncryptData };

            // Fetch asset details
            getAssetTagDetail(oData)
                .then((res) => {
                    if (res?.data?.data) {
                        setErrMsg('');
                        const {
                            data: {
                                data: [assetTagInfo],
                                data_image: assetTagImage,
                                data1: [assetInfo = {}],
                                data2: [allocationInfo = {}],
                                data3: [capitalizationInfo = {}],
                                data4: [depreciationInfo = {}],
                                data5: internalRepairLog = [],
                                data6: externalRepairLog = [],
                                data7: internalTransferLog = [],
                                data8: branchTransferLog = [],
                                data9: imageDetails = [],
                            },
                        } = res.data;

                        setAssetTagInfo(assetTagInfo || {});
                        setImageList(assetTagImage || []);
                        setAssetInfo(assetInfo);
                        setAllocationInfo(allocationInfo);
                        setCapitalizationInfo(capitalizationInfo);
                        setDepreciationInfo(depreciationInfo);
                        setInternalRepair(internalRepairLog[0] || {});
                        setAssetInternalRepairLog(internalRepairLog);
                        setExternalRepair(externalRepairLog[0] || {});
                        setAssetExternalRepairLog(externalRepairLog);
                        setInternalTransfer(internalTransferLog[0] || {});
                        setAssetInternalTransferLog(internalTransferLog);
                        setBranchTransfer(branchTransferLog[0] || {});
                        setAssetBranchTransferLog(branchTransferLog);
                        setAssetImages(imageDetails);
                        setAllImageList(imageDetails);

                        // Update data availability
                        setDataAvailability({
                            assetInfo: res.data.data.data1.length > 0,
                            allocationInfo: res.data.data.data2.length > 0,
                            capitalizationInfo: res.data.data.data3.length > 0,
                            depreciationInfo: res.data.data.data4.length > 0,
                            internalRepair: res.data.data.data5.length > 0,
                            externalRepair: res.data.data.data6.length > 0,
                            internalTransfer: res.data.data.data7.length > 0,
                            branchTransfer: res.data.data.data8.length > 0,
                            imageDetails: res.data.data.data9.length > 0,
                        });

                        // Format equipment list for internal repair log
                        if (internalRepairLog.length > 0) {
                            const formattedEquipment = internalRepairLog.map((item) => ({
                                label: item.tag_name || 'No Tag Name',
                                value: item.tag || 'No Tag',
                            }));
                            setListData1(formattedEquipment);
                            setDescriptions(internalRepairLog.map((item) => item.equipment_desc || ''));
                        }
                    } else {
                        setErrMsg('Assets Not Found');
                        setAssetInfo({});
                        setDataAvailability(null);
                    }
                })
                .catch((error) => {
                    console.error('Error fetching asset details:', error);
                    setErrMsg('Error fetching asset details');
                    setDataAvailability(null);
                });

            // Fetch departments
            getDepartmentList(oData)
                .then((res) => {
                    if (res?.data?.data?.length) setDepartments(res.data.data);
                })
                .catch((error) => {
                    console.error('Error fetching departments:', error);
                });
        } catch (error) {
            console.error('Error decrypting tag:', error);
            setErrMsg('Invalid Tag');
            setDataAvailability(null);
        }
    }, [Tag]);

    // Modal handlers
    const handlePreviewImage = async (imageId, imageName, headTitle) => {
        try {
            setHeadTitle(headTitle);
            setImageName(imageName);
            setPreviewImage(imageId);
            setShowModal(true);
        } catch (error) {
            console.error('Error previewing image:', error);
        }
    };

    const handleBackClick = () => navigate(-1);

    // Render
    return (
        <div className="container">
            {errMsg && <div className="alert alert-danger">{errMsg}</div>}

            <div className="row">
                <div className="col-6">
                    <h5>Product Life Cycle</h5>
                </div>
                <div className="col-5 text-right">
                    <button onClick={handleBackClick} className="btn btn-secondary btn-sm ms-3">
                        Back
                    </button>
                </div>
            </div>

            <div className="row g-4">
                {/* Left Panel */}
                <div className="col-md-4 d-flex">
                    <div className="card border-0 shadow-sm w-100 text-center p-3 d-flex flex-column justify-content-between">
                        <div>
                            <div className="card-header bg-white border-0 text-center">
                                <h5 className="mb-0 text-secondary">Asset Image</h5>
                            </div>
                            <div className="rounded bg-light d-flex align-items-center justify-content-center mx-auto" style={{ height: '200px' }}>
                                {imageList?.length && Array.isArray(imageList) ? (
                                    imageList
                                        .filter((option) => option.asset_dimension === 'front')
                                        .map((option) => (
                                            <img
                                                key={option.asset_image}
                                                onClick={() => handlePreviewImage(option.asset_image_url, option.asset_image, 'Front')}
                                                className="img-fluid"
                                                src={option.asset_image_url}
                                                alt="Front view"
                                                style={{ width: 150, height: 150, border: '1px solid #ccc' }}
                                            />
                                        ))
                                ) : (
                                    <i className="bi bi-image fs-1 text-muted"></i>
                                )}
                            </div>
                        </div>
                        <div className="d-flex gap-2 mt-4">
                            <button className="btn btn-outline-warning w-50 rounded-pill" onClick={() => setActiveSection('timeline')}>
                                Timeline
                            </button>
                            <button className="btn btn-outline-primary w-50 rounded-pill" onClick={() => setActiveSection('details')}>
                                Detail View
                            </button>
                        </div>
                    </div>
                </div>

                {/* Right Panel */}
                <div className="col-md-8 d-flex">
                    <div className="card shadow-sm border-0 w-100 d-flex flex-column">
                        <div className="card-header bg-white border-0 text-center">
                            <h5 className="mb-0 text-secondary">Asset Information</h5>
                        </div>
                        <div className="card-body p-0">
                            <div className="mx-2 mb-2">
                                <table className="table table-bordered table-sm align-middle mb-0">
                                    <tbody>
                                    {[
                                        { label: 'TAG', key: 'tag' },
                                        { label: 'Name of the Asset', key: 'tag_name' },
                                        { label: 'Asset Status', key: 'status', isStatus: true },
                                        { label: 'Current Location of Asset', key: 'site_id' },
                                        { label: 'Date of Purchase', key: (info) => getFormattedDate(info.invoice_date) },
                                        { label: 'Date of Put to Use', key: (info) => getFormattedDate(info.put_to_use_date) },
                                        { label: 'Date of Capitalization', key: (info) => getFormattedDate(info.asset_in_use_date) },
                                        { label: 'Purchase Value of Asset', key: 'total_cost_without_tax' },
                                        { label: 'Accumulated Depreciation of Asset', key: 'depreciation_cb' },
                                        { label: 'WDV of the Asset', key: 'wdv_cb' },
                                    ].map((field, index) => {
                                        const value = typeof field.key === 'function' ? field.key(assetTagInfo) : assetTagInfo[field.key];
                                        const displayValue = field.isStatus ? (value === 1 ? 'Active' : 'Not Active') : value ?? 'NA';
                                        return (
                                            <tr key={index} className="align-middle" style={{ lineHeight: '1.8' }}>
                                                <th className="bg-light w-50">{field.label}</th>
                                                <td>{displayValue}</td>
                                            </tr>
                                        );
                                    })}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Timeline Section */}
            {activeSection === 'timeline' && (
                <div className="timeline-wrapper mt-2">
                    <h5 className="mb-2 text-center">Asset Timeline View</h5>
                    <div className="timeline-track">
                        {filteredTimelineItems.map((item, index) => (
                            <div
                                key={index}
                                className={`timeline-event ${index % 2 === 0 ? 'top' : 'bottom'} ${!item.hasData ? 'no-data' : ''}`}
                                onClick={item.clickable ? item.onClick : undefined}
                                style={item.clickable ? { cursor: 'pointer' } : { cursor: 'default' }}
                            >
                                <div className="timeline-dot">
                                    {item.icon === 'custom' ? (
                                        <img src={item.imgSrc} alt={item.label} style={{ width: '24px', height: '24px' }} />
                                    ) : (
                                        <i className={`bi ${item.icon}`}></i>
                                    )}
                                </div>
                                <div className="timeline-label">{item.label}</div>
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {/* Details Section */}
            {activeSection === 'details' && (
                <div className="row mt-2">
                    <div className="col text-center">
                        <h5 className="mb-2">Asset Detail View</h5>
                        <div className="d-flex flex-wrap justify-content-center gap-3">
                            {filteredTabItems.map((tab, index) => (
                                <div
                                    key={index}
                                    className={`tab-card px-4 py-3 shadow-sm rounded-pill d-flex align-items-center ${!tab.hasData ? 'no-data' : ''}`}
                                    onClick={tab.clickable && tab.hasData ? tab.onClick : undefined}
                                    style={{
                                        cursor: tab.clickable && tab.hasData ? 'pointer' : 'default',
                                        background: !tab.hasData ? '#f1f3f5' : '#fff',
                                    }}
                                >
                                    {tab.icon === 'custom' ? (
                                        <img src={tab.imgSrc} alt={tab.label} className="me-2" style={{ width: '20px', height: '20px' }} />
                                    ) : (
                                        <i className={`bi ${tab.icon} me-2 text-primary`}></i>
                                    )}
                                    <span>{`${index + 1}. ${tab.label}`}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            )}

            {/* Modals */}
            {showModal && (
                <div className="modal-overlay" onClick={() => setShowModal(false)}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header">
                            <h5>Asset Info</h5>
                            <button className="close-btn" onClick={() => setShowModal(false)}>×</button>
                        </div>
                        <div className="modal-body">
                            <table className="table table-bordered table-sm">
                                <tbody>
                                <tr>
                                    <th>TAG</th>
                                    <td>{assetInfo.tag || 'NA'}</td>
                                </tr>
                                <tr>
                                    <th>Name of the Asset</th>
                                    <td>{assetInfo.tag_name || 'NA'}</td>
                                </tr>
                                <tr>
                                    <th>Asset Status</th>
                                    <td>{assetInfo.status === 1 ? 'Active' : 'Not Active'}</td>
                                </tr>
                                <tr>
                                    <th>Current Location</th>
                                    <td>{assetInfo.current_location || 'NA'}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-secondary" onClick={() => setShowModal(false)}>Close</button>
                        </div>
                    </div>
                </div>
            )}

            {showModalAllocation && (
                <div className="modal-overlay" onClick={() => setShowModalAllocation(false)}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header">
                            <h5>Allocation Info</h5>
                            <button className="close-btn" onClick={() => setShowModalAllocation(false)}>×</button>
                        </div>
                        <div className="modal-body">
                            <table className="table table-bordered table-sm">
                                <tbody>
                                <tr>
                                    <th>Tag</th>
                                    <td>{allocationInfo.tag || 'NA'}</td>
                                </tr>
                                <tr>
                                    <th>Premises</th>
                                    <td>{allocationInfo.premises || 'NA'}</td>
                                </tr>
                                <tr>
                                    <th>Floor</th>
                                    <td>{allocationInfo.floor || 'NA'}</td>
                                </tr>
                                <tr>
                                    <th>Rack Id</th>
                                    <td>{allocationInfo.rack_id || 'NA'}</td>
                                </tr>
                                <tr>
                                    <th>Allocation Date</th>
                                    <td>{allocationInfo.effective_date || 'NA'}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-secondary" onClick={() => setShowModalAllocation(false)}>Close</button>
                        </div>
                    </div>
                </div>
            )}

            {showModalCapitalization && (
                <div className="modal-overlay" onClick={() => setShowModalCapitalization(false)}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header">
                            <h5>Capitalization Info</h5>
                            <button className="close-btn" onClick={() => setShowModalCapitalization(false)}>×</button>
                        </div>
                        <div className="modal-body">
                            <table className="table table-bordered table-sm">
                                <tbody>
                                <tr>
                                    <th>Tag</th>
                                    <td>{capitalizationInfo.tag || 'NA'}</td>
                                </tr>
                                <tr>
                                    <th>Date of Capitalization</th>
                                    <td>{getFormattedDate(capitalizationInfo.asset_in_use_date) || 'NA'}</td>
                                </tr>
                                <tr>
                                    <th>Class of Asset</th>
                                    <td>{capitalizationInfo.class_of_asset || 'NA'}</td>
                                </tr>
                                <tr>
                                    <th>Record Start Date</th>
                                    <td>{getFormattedDate(capitalizationInfo.record_start_date) || 'NA'}</td>
                                </tr>
                                <tr>
                                    <th>Pre Capitalized Asset Value</th>
                                    <td>{capitalizationInfo.pre_capitalized_asset_value || 'NA'}</td>
                                </tr>
                                <tr>
                                    <th>Capitalized Asset Value</th>
                                    <td>{capitalizationInfo.igaap_capitalized_value || 'NA'}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-secondary" onClick={() => setShowModalCapitalization(false)}>Close</button>
                        </div>
                    </div>
                </div>
            )}

            {showModalDepreciation && (
                <div className="modal-overlay" onClick={() => setShowModalDepreciation(false)}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header">
                            <h5>Depreciation Info</h5>
                            <button className="close-btn" onClick={() => setShowModalDepreciation(false)}>×</button>
                        </div>
                        <div className="modal-body">
                            <table className="table table-bordered table-sm">
                                <tbody>
                                <tr>
                                    <th>Tag</th>
                                    <td>{depreciationInfo.tag || 'NA'}</td>
                                </tr>
                                <tr>
                                    <th>Date of Depreciation</th>
                                    <td>{getFormattedDate(depreciationInfo.depreciation_date) || 'NA'}</td>
                                </tr>
                                <tr>
                                    <th>Asset OB</th>
                                    <td>{depreciationInfo.asset_ob || 'NA'}</td>
                                </tr>
                                <tr>
                                    <th>Asset Added Value</th>
                                    <td>{depreciationInfo.asset_added_value || 'NA'}</td>
                                </tr>
                                <tr>
                                    <th>Asset CB</th>
                                    <td>{depreciationInfo.asset_cb || 'NA'}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-secondary" onClick={() => setShowModalDepreciation(false)}>Close</button>
                        </div>
                    </div>
                </div>
            )}

            {showModalInternal && (
                <div className="modal-overlay" onClick={() => setShowModalInternal(false)}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header">
                            <h5>Internal Repair</h5>
                            <button className="close-btn" onClick={() => setShowModalInternal(false)}>×</button>
                        </div>
                        <div className="modal-body">
                            <table className="table table-bordered table-sm">
                                <tbody>
                                <tr>
                                    <th>Tag</th>
                                    <td>{internalRepair.tag || 'NA'}</td>
                                </tr>
                                <tr>
                                    <th>Tag Name</th>
                                    <td>{internalRepair.tag_name || 'NA'}</td>
                                </tr>
                                <tr>
                                    <th>Assignment No</th>
                                    <td>{internalRepair.assignment_no || 'NA'}</td>
                                </tr>
                                <tr>
                                    <th>Assignment Date</th>
                                    <td>{getFormattedDate(internalRepair.assignedDate) || 'NA'}</td>
                                </tr>
                                <tr>
                                    <th>Assignment Category</th>
                                    <td>{internalRepair.cat_ir || 'NA'}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-secondary" onClick={() => setShowModalInternal(false)}>Close</button>
                        </div>
                    </div>
                </div>
            )}

            {showModalExternal && (
                <div className="modal-overlay" onClick={() => setShowModalExternal(false)}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header">
                            <h5>External Repair</h5>
                            <button className="close-btn" onClick={() => setShowModalExternal(false)}>×</button>
                        </div>
                        <div className="modal-body">
                            <table className="table table-bordered table-sm">
                                <tbody>
                                <tr>
                                    <th>Tag</th>
                                    <td>{externalRepair.tag || 'NA'}</td>
                                </tr>
                                <tr>
                                    <th>Tag Name</th>
                                    <td>{externalRepair.tag_name || 'NA'}</td>
                                </tr>
                                <tr>
                                    <th>Assignment No</th>
                                    <td>{externalRepair.assignment_no || 'NA'}</td>
                                </tr>
                                <tr>
                                    <th>Assignment Date</th>
                                    <td>{getFormattedDate(externalRepair.assigned_date) || 'NA'}</td>
                                </tr>
                                <tr>
                                    <th>Assignment Category</th>
                                    <td>{externalRepair.cat_ir || 'NA'}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-secondary" onClick={() => setShowModalExternal(false)}>Close</button>
                        </div>
                    </div>
                </div>
            )}

            {showModalFlagging && (
                <div className="modal-overlay" onClick={() => setShowModalFlagging(false)}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header">
                            <h5>Internal Transfer</h5>
                            <button className="close-btn" onClick={() => setShowModalFlagging(false)}>×</button>
                        </div>
                        <div className="modal-body">
                            <table className="table table-bordered table-sm">
                                <tbody>
                                <tr>
                                    <th>Tag</th>
                                    <td>{internalTransfer.tag || 'NA'}</td>
                                </tr>
                                <tr>
                                    <th>Tin No</th>
                                    <td>{internalTransfer.tin_no || 'NA'}</td>
                                </tr>
                                <tr>
                                    <th>Current Status</th>
                                    <td>{internalTransfer.current_status || 'NA'}</td>
                                </tr>
                                <tr>
                                    <th>Movement Initiated By</th>
                                    <td>{internalTransfer.movement_initiated_by || 'NA'}</td>
                                </tr>
                                <tr>
                                    <th>Movement Initiated Date</th>
                                    <td>{getFormattedDate(internalTransfer.initiated_date) || 'NA'}</td>
                                </tr>
                                <tr>
                                    <th>Movement Authorized By</th>
                                    <td>{internalTransfer.movement_authorized_by || 'NA'}</td>
                                </tr>
                                <tr>
                                    <th>Movement Authorization Date</th>
                                    <td>{getFormattedDate(internalTransfer.authorization_date) || 'NA'}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-secondary" onClick={() => setShowModalFlagging(false)}>Close</button>
                        </div>
                    </div>
                </div>
            )}

            {showModalBranchTransfer && (
                <div className="modal-overlay" onClick={() => setShowModalBranchTransfer(false)}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header">
                            <h5>Branch Transfer</h5>
                            <button className="close-btn" onClick={() => setShowModalBranchTransfer(false)}>×</button>
                        </div>
                        <div className="modal-body">
                            <table className="table table-bordered table-sm">
                                <tbody>
                                <tr>
                                    <th>Tag</th>
                                    <td>{branchTransfer.tag || 'NA'}</td>
                                </tr>
                                <tr>
                                    <th>Tin No</th>
                                    <td>{branchTransfer.tin_no || 'NA'}</td>
                                </tr>
                                <tr>
                                    <th>Current Status</th>
                                    <td>{branchTransfer.current_status || 'NA'}</td>
                                </tr>
                                <tr>
                                    <th>Movement Initiated By</th>
                                    <td>{branchTransfer.movement_initiated_by || 'NA'}</td>
                                </tr>
                                <tr>
                                    <th>Movement Initiated Date</th>
                                    <td>{getFormattedDate(branchTransfer.initiated_date) || 'NA'}</td>
                                </tr>
                                <tr>
                                    <th>Movement Authorized By</th>
                                    <td>{branchTransfer.movement_authorized_by || 'NA'}</td>
                                </tr>
                                <tr>
                                    <th>Movement Authorization Date</th>
                                    <td>{getFormattedDate(branchTransfer.authorization_date) || 'NA'}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-secondary" onClick={() => setShowModalBranchTransfer(false)}>Close</button>
                        </div>
                    </div>
                </div>
            )}

            {/* Detail View Modals */}
            {showModalDetailsView && (
                <div className="modal-overlay" onClick={() => setShowModalDetailsView(false)}>
                    <div className="modal-content1" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header">
                            <h5>Asset Detail Info</h5>
                            <button className="close-btn" onClick={() => setShowModalDetailsView(false)}>×</button>
                        </div>
                        <div className="modal-body">
                            {assetInfo ? (
                                <>
                                    <div className="row">
                                        <div className="col">
                                            <FromFieldText readOnly label="TAG" inputValue={assetInfo.tag || 'NA'} />
                                        </div>
                                        <div className="col">
                                            <FromFieldText readOnly label="Parent TAG" inputValue={assetInfo.parent_tag || 'NA'} />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <FromFieldText readOnly label="Year of Addition" inputValue={assetInfo.year_of_addition || 'NA'} />
                                        </div>
                                        <div className="col">
                                            <FromFieldText readOnly label="Type of Addition" inputValue={assetInfo.type_of_addition || 'NA'} />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <FromFieldText readOnly label="Project Marking" inputValue={assetInfo.project_marking || 'NA'} />
                                        </div>
                                        <div className="col">
                                            <FromFieldText readOnly label="PO No (If Any)" inputValue={assetInfo.po_no || 'NA'} />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <FromFieldText readOnly label="Supplier Code (if Any)" inputValue={assetInfo.supplier_code || 'NA'} />
                                        </div>
                                        <div className="col">
                                            <FromFieldText readOnly label="Name of the Supplier" inputValue={assetInfo.supplier_name || 'NA'} />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <FromFieldText readOnly label="Invoice No" inputValue={assetInfo.invoice_no || 'NA'} />
                                        </div>
                                        <div className="col">
                                            <FromFieldText readOnly label="Invoice Date" inputValue={getFormattedDate(assetInfo.invoice_date) || 'NA'} />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <FromFieldText readOnly label="Bill of Entry No" inputValue={assetInfo.boe_no || 'NA'} />
                                        </div>
                                        <div className="col">
                                            <FromFieldText readOnly label="Date of BOE" inputValue={getFormattedDate(assetInfo.boe_date) || 'NA'} />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <FromFieldText readOnly label="Shipping / AWB No" inputValue={assetInfo.shipping_awb_no || 'NA'} />
                                        </div>
                                        <div className="col">
                                            <FromFieldText readOnly label="Date of Shipping/AWB" inputValue={getFormattedDate(assetInfo.shipping_awb_date) || 'NA'} />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <FromFieldText readOnly label="Accounting Voucher No." inputValue={assetInfo.accounting_voucher_no || 'NA'} />
                                        </div>
                                        <div className="col">
                                            <FromFieldText readOnly label="Internal Approval No" inputValue={assetInfo.internal_approval_no || 'NA'} />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <FromFieldText readOnly label="Cost Center Code" inputValue={assetInfo.cost_center_code || 'NA'} />
                                        </div>
                                        <div className="col">
                                            <FromFieldText readOnly label="Cost Center Name" inputValue={assetInfo.cost_center_name || 'NA'} />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <FromFieldText readOnly label="Invoice Currency" inputValue={assetInfo.invoice_currency || 'NA'} />
                                        </div>
                                        <div className="col">
                                            <FromFieldNumber readOnly label="Exchange Rate" inputValue={assetInfo.exchange_rate || 'NA'} />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <FromFieldNumber readOnly label="Basic Cost p.u in Fx" inputValue={assetInfo.invoice_value_fx || 'NA'} />
                                        </div>
                                        <div className="col">
                                            <FromFieldNumber readOnly label="Basic Cost p.u in INR" inputValue={assetInfo.invoice_value_inr || 'NA'} />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <FromFieldNumber readOnly label="Forwarding & Insurance" inputValue={assetInfo.forwarding_and_insurance || 'NA'} />
                                        </div>
                                        <div className="col">
                                            <FromFieldNumber readOnly label="Installation" inputValue={assetInfo.installation || 'NA'} />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <FromFieldNumber readOnly label="Erection" inputValue={assetInfo.errection || 'NA'} />
                                        </div>
                                        <div className="col">
                                            <FromFieldNumber readOnly label="Total Cost Without Tax p.u" inputValue={assetInfo.total_cost_without_tax || 'NA'} />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <FromFieldNumber readOnly label="Customs" inputValue={assetInfo.customs || 'NA'} />
                                        </div>
                                        <div className="col">
                                            <FromFieldNumber readOnly label="CGST" inputValue={assetInfo.cgst || 'NA'} />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <FromFieldNumber readOnly label="SGST" inputValue={assetInfo.sgst || 'NA'} />
                                        </div>
                                        <div className="col">
                                            <FromFieldNumber readOnly label="IGST" inputValue={assetInfo.igst || 'NA'} />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <FromFieldNumber readOnly label="Other Taxes" inputValue={assetInfo.other_taxes || 'NA'} />
                                        </div>
                                        <div className="col">
                                            <FromFieldNumber readOnly label="Total Tax p.u" inputValue={assetInfo.total_tax || 'NA'} />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <FromFieldNumber readOnly label="Total Cost with Tax p.u" inputValue={assetInfo.value_of_asset || 'NA'} />
                                        </div>
                                        <div className="col">
                                            <FromFieldNumber readOnly label="Qty" inputValue={assetInfo.qty || 'NA'} />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <FromFieldText readOnly label="Unit Of Measure" inputValue={assetInfo.unit_of_measure || 'NA'} />
                                        </div>
                                        <div className="col">
                                            <FromFieldText readOnly label="Name of the Asset (as per Invoice)" inputValue={assetInfo.asset_name || 'NA'} />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <FromFieldText readOnly label="Detailed Description of the Asset" inputValue={assetInfo.asset_description || 'NA'} />
                                        </div>
                                        <div className="col">
                                            <FromFieldText readOnly label="Nature of Presence" inputValue={assetInfo.nature_of_presence || 'NA'} />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <FromFieldText readOnly label="Nature of Addition" inputValue={assetInfo.nature_of_addition || 'NA'} />
                                        </div>
                                        <div className="col">
                                            <FromFieldText readOnly label="Principal Asset to which Cost is Added" inputValue={assetInfo.principal_asset_tag || 'NA'} />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <FromFieldText readOnly label="Unique Sl No of the Asset" inputValue={assetInfo.asset_serial_no || 'NA'} />
                                        </div>
                                        <div className="col">
                                            <FromFieldText readOnly label="Make / Manufacturer" inputValue={assetInfo.manufacturer || 'NA'} />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <FromFieldText readOnly label="Model No" inputValue={assetInfo.model_no || 'NA'} />
                                        </div>
                                        <div className="col">
                                            <FromFieldText readOnly label="Part No" inputValue={assetInfo.part_no || 'NA'} />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <FromFieldText readOnly label="Comp Ref. No." inputValue={assetInfo.comp_ref_no || 'NA'} />
                                        </div>
                                        <div className="col">
                                            <FromFieldText readOnly label="Asset TAG Name" inputValue={assetInfo.tag_name || 'NA'} />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <FromFieldText readOnly label="Asset TAG Branch" inputValue={assetInfo.tag_division || 'NA'} />
                                        </div>
                                        <div className="col">
                                            <FromFieldText
                                                readOnly
                                                label="Control Department"
                                                inputValue={
                                                    departments?.length
                                                        ? departments
                                                        .filter((option) => assetInfo.ownership_id === option.id)
                                                        .map((option) => option.department_name)
                                                        .join(', ') || 'NA'
                                                        : 'NA'
                                                }
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <FromFieldText readOnly label="Security Seal Date" inputValue={getFormattedDate(assetInfo.security_seal_date) || 'NA'} />
                                        </div>
                                    </div>
                                </>
                            ) : (
                                <p>No asset information available.</p>
                            )}
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-secondary" onClick={() => setShowModalDetailsView(false)}>Close</button>
                        </div>
                    </div>
                </div>
            )}

            {showModalAllocationDetailsView && (
                <div className="modal-overlay" onClick={() => setShowModalAllocationDetailsView(false)}>
                    <div className="modal-content1" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header">
                            <h5>Asset Allocation Detail Info</h5>
                            <button className="close-btn" onClick={() => setShowModalAllocationDetailsView(false)}>×</button>
                        </div>
                        <div className="modal-body">
                            {allocationInfo ? (
                                <>
                                    <div className="row">
                                        <div className="col">
                                            <FromFieldText readOnly label="TAG" inputValue={allocationInfo.tag || 'NA'} />
                                        </div>
                                        <div className="col">
                                            <FromFieldText readOnly label="Division" inputValue={allocationInfo.division_name || 'NA'} />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <FromFieldText readOnly label="Premises" inputValue={allocationInfo.premises || 'NA'} />
                                        </div>
                                        <div className="col">
                                            <FromFieldText readOnly label="Floor" inputValue={allocationInfo.floor || 'NA'} />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <FromFieldText readOnly label="Site ID" inputValue={allocationInfo.site_id || 'NA'} />
                                        </div>
                                        <div className="col">
                                            <FromFieldText readOnly label="Rack Id" inputValue={allocationInfo.rack_id || 'NA'} />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <FromFieldText readOnly label="User Type" inputValue={allocationInfo.user_type || 'NA'} />
                                        </div>
                                        <div className="col">
                                            <FromFieldText readOnly label="User Department" inputValue={allocationInfo.user_department || 'NA'} />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <FromFieldText readOnly label="Employee ID" inputValue={allocationInfo.employee_id || 'NA'} />
                                        </div>
                                        <div className="col">
                                            <FromFieldText readOnly label="Employee Name" inputValue={allocationInfo.employee_name || 'NA'} />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <FromFieldText readOnly label="User Mail ID" inputValue={allocationInfo.user_mail_id || 'NA'} />
                                        </div>
                                        <div className="col">
                                            <FromFieldText readOnly label="Eligible for Alternative Verification" inputValue={allocationInfo.alternative_verification || 'NA'} />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <FromFieldText readOnly label="Start Date of Allocation" inputValue={allocationInfo.effective_date || 'NA'} />
                                        </div>
                                        <div className="col">
                                            <FromFieldText readOnly label="Select for child allocation" inputValue={allocationInfo.child_allocation || 'NA'} />
                                        </div>
                                    </div>
                                </>
                            ) : (
                                <p>No allocation information available.</p>
                            )}
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-secondary" onClick={() => setShowModalAllocationDetailsView(false)}>Close</button>
                        </div>
                    </div>
                </div>
            )}

            {showModalCapitalizationDetailsView && (
                <div className="modal-overlay" onClick={() => setShowModalCapitalizationDetailsView(false)}>
                    <div className="modal-content1" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header">
                            <h5>Asset Capitalization Detail Info</h5>
                            <button className="close-btn" onClick={() => setShowModalCapitalizationDetailsView(false)}>×</button>
                        </div>
                        <div className="modal-body">
                            {capitalizationInfo ? (
                                <>
                                    <div className="row">
                                        <div className="col">
                                            <FromFieldText readOnly label="TAG" inputValue={capitalizationInfo.tag || 'NA'} />
                                        </div>
                                        <div className="col">
                                            <FromFieldText readOnly label="Class of Asset" inputValue={capitalizationInfo.class_of_asset || 'NA'} />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <FromFieldText readOnly label="Record Start Date" inputValue={getFormattedDate(capitalizationInfo.record_start_date) || 'NA'} />
                                        </div>
                                        <div className="col">
                                            <FromFieldText readOnly label="Parent TAG" inputValue={capitalizationInfo.parent_tag || 'NA'} />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <FromFieldText readOnly label="Depreciation mode" inputValue={capitalizationInfo.cap_type_of_asset || 'NA'} />
                                        </div>
                                        <div className="col">
                                            <FromFieldText
                                                readOnly
                                                label="Date of Capitalization / Asset Ready To Use"
                                                inputValue={getFormattedDate(capitalizationInfo.asset_in_use_date) || 'NA'}
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <FromFieldText readOnly label="Type of Depreciation" inputValue={capitalizationInfo.type_of_depreciation || 'NA'} />
                                        </div>
                                        <div className="col">
                                            <FromFieldNumber readOnly label="Depreciation Rate (No. of years)" inputValue={capitalizationInfo.depreciation_rate || 'NA'} />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <FromFieldText readOnly label="End Date" inputValue={getFormattedDate(capitalizationInfo.depreciation_end_date) || 'NA'} />
                                        </div>
                                        <div className="col">
                                            <FromFieldText readOnly label="Accounting Code of Asset" inputValue={capitalizationInfo.accounting_code || 'NA'} />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <FromFieldText readOnly label="Accounting Name of the Asset" inputValue={capitalizationInfo.accounting_name || 'NA'} />
                                        </div>
                                        <div className="col">
                                            <FromFieldText readOnly label="Financials Classification" inputValue={capitalizationInfo.category_name || 'NA'} />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <FromFieldText readOnly label="Put to Use Date [IT]" inputValue={getFormattedDate(capitalizationInfo.put_to_use_date) || 'NA'} />
                                        </div>
                                        <div className="col">
                                            <FromFieldText readOnly label="Final Asset Capitalization Flag" inputValue={capitalizationInfo.capitalization_flag || 'NA'} />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <FromFieldText readOnly label="Is Tax Capitalized" inputValue={capitalizationInfo.is_tax_capitalized || 'NA'} />
                                        </div>
                                        <div className="col">
                                            <FromFieldText readOnly label="Invoice Currency" inputValue={capitalizationInfo.invoice_currency || 'NA'} />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <FromFieldNumber readOnly label="Exchange Rate" inputValue={capitalizationInfo.exchange_rate || 'NA'} />
                                        </div>
                                        <div className="col">
                                            <FromFieldText readOnly label="Is 100% Depreciable Asset" inputValue={capitalizationInfo.is_100_perc_depreciable || 'NA'} />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <FromFieldNumber readOnly label="Pre Capitalized Asset Value" inputValue={capitalizationInfo.pre_capitalized_asset_value || 'NA'} />
                                        </div>
                                        <div className="col">
                                            <FromFieldText
                                                readOnly
                                                label="Is any other Accg GAAP Applicable"
                                                inputValue={capitalizationInfo.is_any_other_accg_gaap_applicable || 'NA'}
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <FromFieldNumber
                                                readOnly
                                                label="I-GAAP - Limit for 100% Depreciable Asset (Rs)"
                                                inputValue={capitalizationInfo.igaap_limit_amount || 'NA'}
                                            />
                                        </div>
                                        <div className="col">
                                            <FromFieldNumber readOnly label="Salvage Value" inputValue={capitalizationInfo.salvage_value || 'NA'} />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <FromFieldNumber readOnly label="Capitalized Value (I-GAAP)" inputValue={capitalizationInfo.igaap_capitalized_value || 'NA'} />
                                        </div>
                                    </div>
                                    {capitalizationInfo.is_any_other_accg_gaap_applicable === 'Yes' && (
                                        <>
                                            <div className="row">
                                                <h5>Other-GAAP</h5>
                                                <hr />
                                            </div>
                                            <div className="row">
                                                <div className="col">
                                                    <FromFieldText
                                                        readOnly
                                                        label="Record Start Date [Other-GAAP]"
                                                        inputValue={getFormattedDate(capitalizationInfo.other_record_start_date) || 'NA'}
                                                    />
                                                </div>
                                                <div className="col">
                                                    <FromFieldText
                                                        readOnly
                                                        label="Is 100% Depreciable Asset [Other-GAAP]"
                                                        inputValue={capitalizationInfo.is_100_perc_other_depreciable || 'NA'}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col">
                                                    <FromFieldNumber
                                                        readOnly
                                                        label="Depreciation Rate (No. of years) [Other-GAAP]"
                                                        inputValue={capitalizationInfo.other_depreciation_rate || 'NA'}
                                                    />
                                                </div>
                                                <div className="col">
                                                    <FromFieldText
                                                        readOnly
                                                        label="End Date [Other-GAAP]"
                                                        inputValue={getFormattedDate(capitalizationInfo.depreciation_other_end_date) || 'NA'}
                                                    />
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col">
                                                    <FromFieldNumber
                                                        readOnly
                                                        label="Other-GAAP - Limit for 100% Depreciable Asset (Rs)"
                                                        inputValue={capitalizationInfo.othergaap_limit_amount || 'NA'}
                                                    />
                                                </div>
                                                <div className="col">
                                                    <FromFieldNumber
                                                        readOnly
                                                        label="Capitalized Value (Other GAAP)"
                                                        inputValue={capitalizationInfo.othergaap_capitalized_value || 'NA'}
                                                    />
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </>
                            ) : (
                                <p>No capitalization information available.</p>
                            )}
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-secondary" onClick={() => setShowModalCapitalizationDetailsView(false)}>Close</button>
                        </div>
                    </div>
                </div>
            )}

            {showModalDepreciationDetailsView && (
                <div className="modal-overlay" onClick={() => setShowModalDepreciationDetailsView(false)}>
                    <div className="modal-content1" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header">
                            <h5>Asset Depreciation Detail Info</h5>
                            <button className="close-btn" onClick={() => setShowModalDepreciationDetailsView(false)}>×</button>
                        </div>
                        <div className="modal-body">
                            {depreciationInfo ? (
                                <>
                                    <div className="row">
                                        <div className="col">
                                            <FromFieldText readOnly label="TAG" inputValue={depreciationInfo.tag || 'NA'} />
                                        </div>
                                        <div className="col">
                                            <FromFieldText readOnly label="Date" inputValue={getFormattedDate(depreciationInfo.depreciation_date) || 'NA'} />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <FromFieldText readOnly label="Asset OB" inputValue={depreciationInfo.asset_ob || 'NA'} />
                                        </div>
                                        <div className="col">
                                            <FromFieldText readOnly label="Asset Added Value" inputValue={depreciationInfo.asset_added_value || 'NA'} />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <FromFieldText readOnly label="Asset Deleted Value" inputValue={depreciationInfo.asset_deleted_value || 'NA'} />
                                        </div>
                                        <div className="col">
                                            <FromFieldText readOnly label="Asset CB" inputValue={depreciationInfo.asset_cb || 'NA'} />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <FromFieldText readOnly label="Depreciation OB" inputValue={depreciationInfo.depreciation_ob || 'NA'} />
                                        </div>
                                        <div className="col">
                                            <FromFieldNumber readOnly label="Depreciation Added Value" inputValue={depreciationInfo.depreciation_added_value || 'NA'} />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <FromFieldText readOnly label="Depreciation Deleted Value" inputValue={depreciationInfo.depreciation_deleted_value || 'NA'} />
                                        </div>
                                        <div className="col">
                                            <FromFieldText readOnly label="Depreciation Adjusted Value" inputValue={depreciationInfo.depreciation_adjusted_value || 'NA'} />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <FromFieldText readOnly label="Depreciation CB" inputValue={depreciationInfo.depreciation_cb || 'NA'} />
                                        </div>
                                        <div className="col">
                                            <FromFieldText readOnly label="WDV OB" inputValue={depreciationInfo.wdv_ob || 'NA'} />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col">
                                            <FromFieldText readOnly label="WDV CB" inputValue={depreciationInfo.wdv_cb || 'NA'} />
                                        </div>
                                    </div>
                                </>
                            ) : (
                                <p>No depreciation information available.</p>
                            )}
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-secondary" onClick={() => setShowModalDepreciationDetailsView(false)}>Close</button>
                        </div>
                    </div>
                </div>
            )}

            {showModalInternalRepairView && (
                <div className="modal-overlay" onClick={() => setShowModalInternalRepairView(false)}>
                    <div className="modal-content1" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header">
                            <h5>Asset Internal Repair Info</h5>
                            <button className="close-btn" onClick={() => setShowModalInternalRepairView(false)}>×</button>
                        </div>
                        <div className="modal-body">
                            {assetInternalRepairLog?.length ? (
                                <Box sx={{ height: 500, width: '100%' }}>
                                    <DataGrid
                                        rows={assetInternalRepairLog}
                                        getRowId={(row) => row.id}
                                        columns={columns1}
                                        pageSize={50}
                                        autoHeight
                                        rowsPerPageOptions={[50]}
                                        components={{ Toolbar: CustomToolbar }}
                                    />
                                </Box>
                            ) : (
                                <p>No internal repair information available.</p>
                            )}
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-secondary" onClick={() => setShowModalInternalRepairView(false)}>Close</button>
                        </div>
                    </div>
                </div>
            )}

            {showModalExternalRepairView && (
                <div className="modal-overlay" onClick={() => setShowModalExternalRepairView(false)}>
                    <div className="modal-content1" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header">
                            <h5>Asset External Repair Info</h5>
                            <button className="close-btn" onClick={() => setShowModalExternalRepairView(false)}>×</button>
                        </div>
                        <div className="modal-body">
                            {assetExternalRepairLog?.length ? (
                                <Box sx={{ height: 500, width: '100%' }}>
                                    <DataGrid
                                        rows={assetExternalRepairLog}
                                        getRowId={(row) => row.id}
                                        columns={columns2}
                                        pageSize={50}
                                        autoHeight
                                        rowsPerPageOptions={[50]}
                                        components={{ Toolbar: CustomToolbar }}
                                    />
                                </Box>
                            ) : (
                                <p>No external repair information available.</p>
                            )}
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-secondary" onClick={() => setShowModalExternalRepairView(false)}>Close</button>
                        </div>
                    </div>
                </div>
            )}

            {showModalInternalTransferView && (
                <div className="modal-overlay" onClick={() => setShowModalInternalTransferView(false)}>
                    <div className="modal-content1" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header">
                            <h5>Asset Internal Transfer Info</h5>
                            <button className="close-btn" onClick={() => setShowModalInternalTransferView(false)}>×</button>
                        </div>
                        <div className="modal-body">
                            {assetInternalTransferLog?.length ? (
                                <Box sx={{ height: 500, width: '100%' }}>
                                    <DataGrid
                                        rows={assetInternalTransferLog}
                                        getRowId={(row) => row.id}
                                        columns={columns3}
                                        pageSize={50}
                                        autoHeight
                                        rowsPerPageOptions={[50]}
                                        components={{ Toolbar: CustomToolbar }}
                                    />
                                </Box>
                            ) : (
                                <p>No internal transfer information available.</p>
                            )}
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-secondary" onClick={() => setShowModalInternalTransferView(false)}>Close</button>
                        </div>
                    </div>
                </div>
            )}

            {showModalBranchTransferView && (
                <div className="modal-overlay" onClick={() => setShowModalBranchTransferView(false)}>
                    <div className="modal-content1" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header">
                            <h5>Asset Branch Transfer Info</h5>
                            <button className="close-btn" onClick={() => setShowModalBranchTransferView(false)}>×</button>
                        </div>
                        <div className="modal-body">
                            {assetBranchTransferLog?.length ? (
                                <Box sx={{ height: 500, width: '100%' }}>
                                    <DataGrid
                                        rows={assetBranchTransferLog}
                                        getRowId={(row) => row.id}
                                        columns={columns4}
                                        pageSize={50}
                                        autoHeight
                                        rowsPerPageOptions={[50]}
                                        components={{ Toolbar: CustomToolbar }}
                                    />
                                </Box>
                            ) : (
                                <p>No branch transfer information available.</p>
                            )}
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-secondary" onClick={() => setShowModalBranchTransferView(false)}>Close</button>
                        </div>
                    </div>
                </div>
            )}

            {showModalImageView && (
                <div className="modal-overlay" onClick={() => setShowModalImageView(false)}>
                    <div className="modal-content1" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header">
                            <h5>Asset Image Info</h5>
                            <button className="close-btn" onClick={() => setShowModalImageView(false)}>×</button>
                        </div>
                        <div className="modal-body">
                            {allImageList?.length ? (
                                <>
                                    {['front', 'back', 'left', 'right', 'top', 'bottom', 'other'].map((dimension) => (
                                        <div key={dimension} className="row" style={{ border: '1px solid #ddd' }}>
                                            <div className="col-12">
                                                <h6 className="text-capitalize">{dimension} View</h6>
                                                <div className="d-flex flex-wrap gap-2">
                                                    {allImageList
                                                        .filter((image) => image.asset_dimension.toLowerCase() === dimension)
                                                        .map((image, idx) => (
                                                            <div key={idx} className="image-preview">
                                                                <img
                                                                    src={image.asset_image_url}
                                                                    alt={`${dimension} view`}
                                                                    style={{ width: '100px', height: '100px', cursor: 'pointer', border: '1px solid #ccc' }}
                                                                    onClick={() => handlePreviewImage(image.asset_image_url, image.asset_image, `${dimension} View`)}
                                                                />
                                                            </div>
                                                        ))}
                                                    {allImageList.filter((image) => image.asset_dimension.toLowerCase() === dimension).length === 0 && (
                                                        <p>No {dimension} view images available.</p>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </>
                            ) : (
                                <p>No asset images available.</p>
                            )}
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-secondary" onClick={() => setShowModalImageView(false)}>Close</button>
                        </div>
                    </div>
                </div>
            )}

            {/* Image Preview Modal */}
            {previewImage && (
                <div className="modal-overlay" onClick={() => { setPreviewImage(null); setShowModal(false); }}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header">
                            <h5>{headTitle} Image</h5>
                            <button className="close-btn" onClick={() => { setPreviewImage(null); setShowModal(false); }}>×</button>
                        </div>
                        <div className="modal-body text-center">
                            <img
                                src={previewImage}
                                alt={imageName}
                                style={{ maxWidth: '100%', maxHeight: '400px' }}
                            />
                            <p className="mt-2">{imageName}</p>
                        </div>
                        <div className="modal-footer">
                            <button className="btn btn-secondary" onClick={() => { setPreviewImage(null); setShowModal(false); }}>Close</button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default PlcDetails;